import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import mainLogo from "../../icons/download.png";
import { getSNJSON } from "../../api/index";
import { useApiAction } from "../../hooks/use-api-action/use-api-action";

const ImageComponent = () => {
  const [data, setData] = useState(false);
  const [OpSJImage, setOpSJImage] = useState({});
  const [fetchImage, performFetchImage] = useApiAction(getSNJSON);

  const dataIntervalRef = useRef(null);
  const imageIntervalRef = useRef(null);
  var imageName = window.location.href.toString().includes("/dashboardimage")
    ? "backlogCX.png"
    : "executiveDashboardImage.png";
  const get_data = () => {
    let url = window.location.href;
    let sn_url =
      "https://soprasteria@@@.service-now.com/api/x_steas_executive/2s_executive_dashboard/getattachmentmetadata";

    if (url.includes("-test")) {
      sn_url = sn_url.replace("@@@", "test");
    } else if (url.includes("-dev")) {
      sn_url = sn_url.replace("@@@", "dev");
    } else {
      sn_url = sn_url.replace("@@@", "");
    }

    axios
      .get(sn_url)
      .then((data) => {
        setData(data["data"]["result"]["base64"]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Setup get_data polling
  useEffect(() => {
    let wait = 120;
    get_data();
    dataIntervalRef.current = setInterval(() => {
      get_data();
    }, wait * 1000);

    return () => {
      clearInterval(dataIntervalRef.current);
    };
  }, []);

  // Setup image fetch polling
  useEffect(() => {
    let wait = 120;
    const Field = ["Get", "urlImage", "?image_name=" + imageName, ""];
    performFetchImage(Field);

    imageIntervalRef.current = setInterval(() => {
      performFetchImage(Field);
    }, wait * 1000);

    return () => {
      clearInterval(imageIntervalRef.current);
    };
  }, []);

  // Monitor result and clear intervals accordingly
  useEffect(() => {
    if (fetchImage.data && fetchImage.data["result"]) {
      const result = fetchImage.data["result"];
      setOpSJImage(result);

      // If result exists, stop get_data polling
      if (result["mainImage"] !== "") {
        clearInterval(dataIntervalRef.current);
        dataIntervalRef.current = null;
      }

      // If mainImage is "", stop image polling
      if (result["mainImage"] === "") {
        if (imageIntervalRef.current) {
          clearInterval(imageIntervalRef.current);
          imageIntervalRef.current = null;
        }
      }
    }
  }, [fetchImage.data]);

  return (
    <div>
      {OpSJImage["mainImage"] || data ? (
        <img
          style={{ width: "100%" }}
          src={
            OpSJImage["mainImage"]
              ? OpSJImage["mainImage"]
              : `data:image/png;base64,${data}`
          }
          alt={OpSJImage["mainImage"] ? "fireSpot" : ""}
        />
      ) : (
        <h1>Loading...</h1>
      )}
    </div>
  );
};

export default ImageComponent;
